<div class="alert alert-warning mx-auto" role="alert" style="max-width: 600px;">
  <div class="alert-message text-center">
    <h4 class="alert-heading">
      User already migrated to OnyxPay
    </h4>

    <p>
      Please remember that you need to log in through this new URL
        <a [href]="o2Url" target="_blank">{{ o2Url }}</a>,
        we will now redirect you there
    </p>

    <div class="text-center mt-3">
      <button
        type="button"
        class="btn btn-primary"
        (click)="goToO2()">
        Accept
      </button>
    </div>
  </div>
</div>